import React from 'react';
import classnames from 'classnames';
import EllipsisHover from '@home/components/EllipsisHover';
import CurrentMilestoneIcon from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/NextMilestoneIcon';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IMilestoneDateCellProps extends IBaseProps {
  isCurrent?: boolean;
  name?: string;
  date?: string;
  dateFormatter?: (payload: string) => string;
}

const MilestoneDateCell: React.FC<IMilestoneDateCellProps> = (props) => {
  const { style, className, isCurrent, name, date, dateFormatter } = props;
  const hasDate = !!date;

  return (
    <div style={style} className={classnames('dbg-project-details__finance__milestone-date-cell', className)}>
      <div
        className={classnames('dbg-project-details__finance__milestone-date-cell__name-date-wrapper', {
          'has-date': hasDate,
        })}
      >
        <div>
          <EllipsisHover text={name} />
        </div>
        <div>({hasDate ? dateFormatter?.(date) ?? date : '-'})</div>
      </div>
      {isCurrent && (
        <CurrentMilestoneIcon
          className="dbg-project-details__finance__milestone-date-cell__current-milestone-icon"
          text="Current"
        />
      )}
    </div>
  );
};

export default MilestoneDateCell;
